const DISMISS_STORAGE_PREFIX = 'juntas_discovery_dismissed_'

export const DISCOVERY_DIMENSIONS = [
  { key: 'lifestyle', label: 'Estilo de vida' },
  { key: 'zones', label: 'Zonas' },
  { key: 'maternity', label: 'Maternidad' },
  { key: 'budget', label: 'Presupuesto' },
  { key: 'schedules', label: 'Horarios' },
]

/** @param {Record<string, unknown>} row — fila RPC get_compatible_matches */
export function normalizeCompatibleMatch(row) {
  return {
    profileId: row.profile_id,
    name: row.name ?? '',
    age: row.age ?? null,
    occupation: row.occupation ?? '',
    presentation: row.presentation ?? '',
    currentZoneId: row.current_zone ?? null,
    score: typeof row.score === 'number' ? row.score : Number(row.score) || 0,
    breakdown: row.breakdown ?? {},
    distanceKm:
      row.distance_km != null && row.distance_km !== ''
        ? Number(row.distance_km)
        : null,
    hasChildren: Boolean(row.has_children),
    budgetMin:
      row.budget_min != null && row.budget_min !== ''
        ? Number(row.budget_min)
        : null,
    budgetMax:
      row.budget_max != null && row.budget_max !== ''
        ? Number(row.budget_max)
        : null,
    smoker: row.smoker ?? 'no',
  }
}

export function profileInitial(name) {
  const trimmed = String(name ?? '').trim()
  return trimmed ? trimmed.charAt(0).toUpperCase() : '?'
}

export function formatDistanceKm(km) {
  if (km == null || Number.isNaN(km)) return null
  if (km < 0.05) return null
  if (km < 1) return `${Math.round(km * 1000)} m`
  return `${km.toFixed(1).replace('.', ',')} km`
}

export function dimensionScores(breakdown) {
  return DISCOVERY_DIMENSIONS.map(({ key, label }) => {
    const dim = breakdown?.[key]
    const score = dim?.score
    return {
      key,
      label,
      score: typeof score === 'number' ? score : Number(score) || null,
    }
  }).filter((d) => d.score != null)
}

function readDismissed(userId) {
  if (!userId) return { passed: [], later: [] }
  try {
    const raw = localStorage.getItem(`${DISMISS_STORAGE_PREFIX}${userId}`)
    if (!raw) return { passed: [], later: [] }
    const parsed = JSON.parse(raw)
    return {
      passed: Array.isArray(parsed.passed) ? parsed.passed : [],
      later: Array.isArray(parsed.later) ? parsed.later : [],
    }
  } catch {
    return { passed: [], later: [] }
  }
}

function writeDismissed(userId, state) {
  if (!userId) return
  localStorage.setItem(`${DISMISS_STORAGE_PREFIX}${userId}`, JSON.stringify(state))
}

export function loadDismissedProfileIds(userId) {
  const { passed, later } = readDismissed(userId)
  return new Set([...passed, ...later])
}

export function dismissProfile(userId, profileId, action) {
  if (!userId || !profileId) return
  const state = readDismissed(userId)
  const id = String(profileId)
  state.passed = state.passed.filter((x) => x !== id)
  state.later = state.later.filter((x) => x !== id)
  if (action === 'passed') state.passed.push(id)
  else if (action === 'later') state.later.push(id)
  writeDismissed(userId, state)
}

/** Annule le dernier dismiss (passed ou later). */
export function undoDismissProfile(userId, profileId, action) {
  if (!userId || !profileId || !action) return
  const state = readDismissed(userId)
  const id = String(profileId)
  if (action === 'passed') state.passed = state.passed.filter((x) => x !== id)
  else if (action === 'later') state.later = state.later.filter((x) => x !== id)
  writeDismissed(userId, state)
}

export function clearLaterDismissals(userId) {
  if (!userId) return
  const state = readDismissed(userId)
  state.later = []
  writeDismissed(userId, state)
}

/** Accès discovery : vérifiée + onboarding + carta. */
export function canAccessDiscovery(profile, cartaAccepted) {
  if (!profile) return false
  if (profile.identity_status !== 'verified') return false
  if (!profile.profile_completed) return false
  if (!cartaAccepted) return false
  return true
}
